import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-end items-center gap-x-2 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isLastMile && !_ctx.isOutgoing && !_ctx.isConsoleBkd)
      ? (_openBlock(), _createBlock(_component_LpButton, {
          key: 0,
          title: "Not Received",
          textColor: "red-lp-100",
          color: "red-lp-100",
          outline: "",
          customClass: "w-full",
          disabled: _ctx.isDisableButton,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateStatus('Not Received')))
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (_ctx.isUpdateMissingEnabled)
      ? (_openBlock(), _createBlock(_component_LpButton, {
          key: 1,
          title: "Missing",
          textColor: "red-lp-100",
          color: "red-lp-100",
          outline: "",
          customClass: "w-full",
          disabled: _ctx.isDisableButton,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateStatus('Missing')))
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (_ctx.isUpdateDamageEnabled)
      ? (_openBlock(), _createBlock(_component_LpButton, {
          key: 2,
          title: "Damage",
          textColor: "red-lp-100",
          color: "red-lp-100",
          outline: "",
          customClass: "w-full",
          disabled: _ctx.isDisableButton,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateStatus('Damage')))
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_LpButton, {
      title: "Download",
      textColor: "white",
      color: "red-lp-100",
      customClass: "w-full",
      iconLeft: "download-new",
      iconV2: "",
      onClick: _ctx.onDownload,
      iconGroupHoverColor: "text-white"
    }, null, 8, ["onClick"])
  ]))
}